import { render, staticRenderFns } from "./AdminSpiderV2.vue?vue&type=template&id=08b06fc9&scoped=true"
import script from "./AdminSpiderV2.vue?vue&type=script&lang=js"
export * from "./AdminSpiderV2.vue?vue&type=script&lang=js"
import style0 from "./AdminSpiderV2.vue?vue&type=style&index=0&id=08b06fc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b06fc9",
  null
  
)

export default component.exports